import { ConditionalLink } from "components/conditionalLink";
import { Button } from "components/DesignSystem/Button/Button";
import { TextInput } from "components/DesignSystem/TextInput/TextInput";
import { LargeCard } from "components/home/Home";
import { ReferAndEarnBG } from "components/TPPayments/Illustration/ReferAndEarnBG";
import { COPIED_TEXT, FAILED_COPIED_TEXT } from "constants/documents";
import { Form, Formik } from "formik";
import { useToast } from "hooks/useToast";
import authContext from "jwt_context&axios/authContext";
import { useContext } from "react";
import CopyIcon from "static/images/CopyPurple.svg";
import ReferLinkedIn from "static/images/ReferLinkedIn.svg";
import ReferMail from "static/images/ReferMail.svg";
import ReferTwitter from "static/images/ReferTwitter.svg";
import ReferWhatsApp from "static/images/ReferWhatsApp.svg";

export const getSocialRedirctLinks = ({
  type,
  referralLink,
}: {
  type: string;
  referralLink: string;
}) => {
  switch (type) {
    case "mail":
      return `mailto:?subject=Get%20%24100%20in%20Inkle%20credits%20using%20my%20referral%20link&body=I%20use%20Inkle%20for%20tax%2C%20compliance%20%26%20accounting%20for%20my%20Delaware%20C-Corp.%20Inkle%20replaces%20a%20CPA%20%26%20provides%20a%20dashboard%20with%20chat%2C%20document%20vault%2C%20deadline%20alerts%20%26%20easy%20workflows.%20%0A%0AUse%20my%20referral%20link%20and%20we'll%20both%20get%20%24100%20worth%20of%20Inkle%20credits%0A${referralLink}`;
    case "twitter":
      return `https://twitter.com/intent/post?text=I%20use%20Inkle%20for%20tax%2C%20compliance%20%26%20accounting%20for%20my%20Delaware%20C-Corp.%20Inkle%20replaces%20a%20CPA%20%26%20provides%20a%20dashboard%20with%20chat%2C%20document%20vault%2C%20deadline%20alerts%20%26%20easy%20workflows.%20Use%20my%20referral%20link%20and%20we%27ll%20both%20get%20%24100%20worth%20of%20Inkle%20credits%3A%20${referralLink}`;
    case "linkedin":
      return `https://www.linkedin.com/feed/?shareActive=true&text=I%20use%20Inkle%20for%20tax%2C%20compliance%20%26%20accounting%20for%20my%20Delaware%20C-Corp.%20Inkle%20replaces%20a%20CPA%20%26%20provides%20a%20dashboard%20with%20chat%2C%20document%20vault%2C%20deadline%20alerts%20%26%20easy%20workflows.%20Use%20my%20referral%20link%20and%20we%27ll%20both%20get%20%24100%20worth%20of%20Inkle%20credits!%20${referralLink}`;
    case "whatsapp":
      return `https://web.whatsapp.com/send?text=https://www.linkedin.com/feed/?shareActive=true&text=Join%20Inkle%20for%20tax%2C%20compliance%20%26%20accounting%20for%20your%20Delaware%20C-Corp.%20Use%20my%20referral%20link%20and%20we%27ll%20both%20get%20%24100%20worth%20of%20Inkle%20credits%3A%20${referralLink}`;
  }
};

const ReferAction = ({ referralLink }: { referralLink: string }) => {
  const linkedInReferralLink = encodeURIComponent(referralLink);

  const mailLink = getSocialRedirctLinks({ type: "mail", referralLink });
  const twitterLink = getSocialRedirctLinks({ type: "twitter", referralLink });
  const linkedInLink = getSocialRedirctLinks({
    type: "linkedin",
    referralLink: linkedInReferralLink,
  });
  const whatsAppLink = getSocialRedirctLinks({
    type: "whatsapp",
    referralLink,
  });

  return (
    <div
      className="t-flex t-flex-col t-gap-2 t-mt-auto"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="t-flex t-gap-3 t-items-center">
        <ConditionalLink to={mailLink}>
          <Button customType="ghost_icon" size="xsmall">
            <img src={ReferMail} alt="Mail" />
          </Button>
        </ConditionalLink>
        <ConditionalLink to={twitterLink}>
          <Button customType="ghost_icon" size="xsmall">
            <img src={ReferTwitter} alt="Twitter" />
          </Button>
        </ConditionalLink>
        <ConditionalLink to={linkedInLink}>
          <Button customType="ghost_icon" size="xsmall">
            <img src={ReferLinkedIn} alt="LinkedIn" />
          </Button>
        </ConditionalLink>
        <ConditionalLink to={whatsAppLink}>
          <Button customType="ghost_icon" size="xsmall">
            <img src={ReferWhatsApp} alt="WhatsApp" />
          </Button>
        </ConditionalLink>
      </div>
      <div className="t-text-caption t-text-text-30">*T&C apply</div>
    </div>
  );
};

export const ReferHomeCard = () => {
  const {
    authtoken: { referral_link },
  } = useContext(authContext);
  const { alertToast, successToast } = useToast();

  const copyToClipBoard = async () => {
    try {
      await navigator.clipboard.writeText(referral_link);
      successToast({ message: COPIED_TEXT });
    } catch (err) {
      alertToast({ message: FAILED_COPIED_TEXT });
    }
    return false;
  };

  return (
    <LargeCard>
      <div
        className="t-relative t-p-5 t-text-text-100 t-bg-auto t-self-start t-w-full t-h-full t-rounded-lg"
        onClick={copyToClipBoard}
        role="button"
      >
        <div className="t-absolute t-top-0 t-left-0 t-h-full t-w-full t-object-cover t-z-[-1]">
          <ReferAndEarnBG />
        </div>
        <div className="t-flex t-flex-col t-justify-between t-h-full t-gap-3">
          <div className="t-flex t-gap-1 t-flex-col t-z-10">
            <p className="t-m-0 t-text-subtitle">
              Refer your friends to Inkle and earn $100*
            </p>
            <div className="t-mt-2">
              <Formik onSubmit={() => {}} initialValues={{}}>
                {() => (
                  <Form className="t-m-0 t-w-full">
                    <TextInput
                      name="referralLink"
                      block
                      value={referral_link}
                      disabled
                      rightComponent={
                        <Button customType="ghost_icon" size="xsmall">
                          <img src={CopyIcon} alt="copyIcon" />
                        </Button>
                      }
                      customSize="small"
                    />
                  </Form>
                )}
              </Formik>
            </div>
          </div>

          <div>
            <ReferAction referralLink={referral_link} />
          </div>
        </div>
      </div>
    </LargeCard>
  );
};
